import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { WinnersComponent } from './winners/winners.component';
import { HeaderLayoutComponent } from './header-layout/header-layout.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { FaqComponent } from './faq/faq.component';

const routes: Routes = [
  {
    path: '',
    /* component: MaintenanceComponent */
    component: HeaderLayoutComponent,
    children: [
      {
        path: 'faq',
        component: FaqComponent
      },
      {
        path: 'winners',
        component: WinnersComponent
      },
      {
        path: '',
        component: DashboardComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
